export default function (value: number, maxDecimal: number = 2) {
  return new Intl.NumberFormat("es-MX", {
    maximumFractionDigits: maxDecimal,
  }).format(value);
}
